/**
 * @desc 供应商文件删除（合同，附件）
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: Array<number>, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierInfo/deleted/supplierFiles`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
